import { AVAILABLE_LOCALES } from '../constants';
import { Locale } from '@/helpers/languages';

export const detectBrowserLanguage = (acceptLanguage: string) => {
  return acceptLanguage
    .split(',')
    .map((lang) => {
      const [code, qValue] = lang.split(';q=');
      return { code: code.trim(), weight: parseFloat(qValue) || 1.0 };
    })
    .sort((a, b) => b.weight - a.weight)
    .find(({ code }) => [...AVAILABLE_LOCALES, 'fr'].includes(code as Locale));
};
